// Date utility functions

// Returns true if the date portion of the two Date objects are the same
export const sameDate = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

// Returns true if the time portion of the two Date objects are the same
//
// Returns false if either is null, but returns true if both are null.
export const sameTime = (a, b) => {
  if (!a && !b) {
    return true;
  }

  return (
    a &&
    b &&
    a.getHours() === b.getHours() &&
    a.getMinutes() === b.getMinutes() &&
    a.getSeconds() === b.getSeconds()
  );
};
